import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import Dropdown from "components/Dropdown";
import DropdownMenu from "components/DropdownMenu";
import DropdownButton from "components/DropdownButton";

import { useApp } from "context/app";

import AvatarImage from "assets/images/avatar-placeholder.png";
import { ReactComponent as LogoutIcon } from "assets/icons/menu/logout.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/menu/settings.svg";

const mainClass = "avatar";

const Avatar = () => {
  const { t } = useTranslation();

  const { user, logout } = useApp();
  const [dropdown_key, setDropdownKey] = useState(0);

  const basics_menu_items = [
    {
      slug: "settings",
      icon: <SettingsIcon />,
      label: t("Settings"),
      href: "/settings",
    },
    {
      slug: "logout",
      icon: <LogoutIcon />,
      label: t("Sign out"),
      action: logout,
    },
  ];

  return (
    <Dropdown
      custom={true}
      Button={({ active }) => (
        <DropdownButton
          active={active}
          component={
            <div className={`${mainClass}__photo`}>
              <img src={user?.photo || AvatarImage} alt="" />
            </div>
          }
        />
      )}
      onclose={dropdown_key}
    >
      <DropdownMenu
        items={basics_menu_items}
        variant="small"
        color="dark"
        icon_type="colorful"
        closeHandler={() => setDropdownKey((prev) => prev + 1)}
      />
    </Dropdown>
  );
};

export default Avatar;
